import React from "react";
import PhoneInput from "react-phone-number-input";

const FormikPhoneInput = React.forwardRef(
  ({ name, onChange, formik, ...rest }, ref) => (
    <PhoneInput international {...rest} ref={ref} name={name} onChange={onChange} />
  )
);

export default FormikPhoneInput;
